<template>
  <q-select
    v-bind="binding"
    :value="value"
    :options="countriesArray"
    class="full-width"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
  />
</template>

<script>
  import { mapGetters } from 'vuex';
  import Countries from 'helpers/geoData/flags';

  export default {
    name: 'FormSelectCountry',
    props: {
      value: {
        type: String,
        required: false,
        default: '',
      },
      color: {
        type: String,
        required: false,
        default: 'primary',
      },
      disable: {
        type: Boolean,
        required: false,
        default: false,
      },
      quasarProps: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
    computed: {
      ...mapGetters('settings', [
        'language',
      ]),
      countriesArray() {
        if (Object.prototype.hasOwnProperty.call(Countries, this.language)) {
          return Countries[this.language];
        }
        return Countries['pt-br'];
      },
      binding() {
        return {
          color: this.color,
          disable: this.disable,
          loading: this.loading,
          filter: true,
          autofocusFilter: true,
          floatLabel: this.$t('field.address.country.label'),
          filterPlaceholder: this.$t('field.address.country.filter'),
          ...this.quasarProps,
};
      },
    },
  };
</script>
